export default [
  {
    path: '/solicitud-modificaciones-calificaciones',
    name: 'solicitud-modificaciones-calificaciones',
    component: () =>
      import(
        '@/views/academico/calificaciones/solicitud-modificacion-calificacion/layouts/SolicitudModificacionCalificacionLayout.vue'
      ),
  }
];
